<div class="min-h-screen flex w-full background-jakarta relative overflow-hidden">
    <!-- Left Side -->
    <div class="hidden lg:flex w-1/2 bg-primary-green min-h-screen items-center justify-center relative z-10">
        <img src="assets/images/pages/login/client-area.png" alt="client-area" class="max-h-[60vh] object-contain drop-shadow-lg" />
    </div>

    <!-- Right Side -->
    <div class="w-full lg:w-1/2 flex items-center justify-center h-screen overflow-y-auto p-4 lg:p-0">
        <div class="bg-white w-full max-w-md rounded-xl shadow-lg p-6">
            <h1 class="text-center text-3xl font-semibold text-gray-800 mb-2">
                Pilih Outlet
            </h1>
            <p class="text-center text-gray-500 text-sm mb-6">
                Silakan pilih outlet yang ingin Anda kelola
            </p>

            <!-- Outlet List -->
            <div class="space-y-3">
                <div *ngFor="let outlet of outlets"
                    (click)="selectOutlet(outlet)"
                    class="p-4 border border-gray-200 rounded-lg cursor-pointer hover:border-primary-green hover:bg-green-50 transition-all duration-200 group">
                    <div class="flex items-center gap-3">
                        <div class="w-12 h-12 bg-primary-green bg-opacity-10 rounded-full flex items-center justify-center">
                            <span class="text-primary-green font-bold text-lg">{{ outlet.code }}</span>
                        </div>
                        <div class="flex-1">
                            <h3 class="font-semibold text-gray-800 group-hover:text-primary-green transition-colors">
                                {{ outlet.name }}
                            </h3>
                            <p class="text-sm text-gray-500">{{ outlet.address }}</p>
                        </div>
                        <div class="text-gray-400 group-hover:text-primary-green transition-colors">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            <p class="text-gray-500 text-sm text-center mt-6">
                © 2026
                <span class="font-semibold">AWH </span>
                . Powered by
                <span class="font-semibold">PT. AWH Inti Nusantara. </span>
            </p>
        </div>
    </div>
</div>
